import React, { useState } from "react"
import VisibilitySensor from "react-visibility-sensor"

const Animate = ({ className = "fade", children, ...rest }) => {
  const [viewPortEntered, setViewPortEntered] = useState(false)

  return (
    <VisibilitySensor
      active={!viewPortEntered}
      onChange={isVisible => {
        if (isVisible) {
          setViewPortEntered(true)
        }
      }}
      delayedCall
      partialVisibility
    >
      <div
        className={`animate-elem ${className} ${viewPortEntered && "inView"}`}
        {...rest}
      >
        {children}
      </div>
    </VisibilitySensor>
  )
}

export default Animate
